import React from "react";
import { FormattedMessage } from "react-intl";

import Label from "../Label";
import Validation from "../Validation";
import Tooltip from "../Tooltip";

import { FormElement, ChangeButton } from "../shared-style";

import InputSelect from "./InputSelect";
import messages from "./messages";
import { IProps } from "./interfaces";

const Select = <T extends string | number | undefined | null>({
    label,
    value,
    onChange,
    disabled,
    name,
    options,
    changeModal,
    validation,
    optionsMinWidth,
    optionsRight,
    lightWithValue,
    minPlaceholder,
    maxPlaceholder,
    required,
    noDelete,
    dark,
    simulation,
    tooltip,
    disableTypeahead,
    showNull,
    forceDirection,
}: IProps<T>) => (
    <FormElement>
        {label && (
            <Label disabled={disabled} required={required}>
                {label}
            </Label>
        )}
        {validation && <Validation validation={validation} />}
        {changeModal && (
            <ChangeButton onClick={() => changeModal(name, value)}>
                <FormattedMessage {...messages.modify} />
            </ChangeButton>
        )}
        <InputSelect
            value={value}
            onChange={onChange}
            disabled={disabled}
            noDelete={noDelete}
            dark={dark}
            optionsMinWidth={optionsMinWidth}
            optionsRight={optionsRight}
            name={name}
            options={options}
            lightWithValue={lightWithValue}
            minPlaceholder={minPlaceholder}
            maxPlaceholder={maxPlaceholder}
            validation={validation}
            simulation={simulation}
            disableTypeahead={disableTypeahead}
            showNull={showNull}
            forceDirection={forceDirection}
        ></InputSelect>
        {tooltip && <Tooltip isSelect>{tooltip}</Tooltip>}
    </FormElement>
);

export default Select;

